const configFirebase = {
  apiKey: "AIzaSyClwbrN0msFzN6PAVdWqWHKBsrHw57QqqE",
  authDomain: "react-scene-generator.firebaseapp.com",
  projectId: "react-scene-generator",
  storageBucket: "react-scene-generator.appspot.com",
  messagingSenderId: "842278695032",
  appId: "1:842278695032:web:2f2773d1dff87e2ea2fd8d",
};

export { configFirebase };
